import React from "react";
import { ExternalLink } from "lucide-react";
import { RESOURCES } from "../data/content";
import Reveal from "../components/Reveal";

export default function Resources() {
  return (
    <div data-testid="resources-page">
      <section className="bg-[#0A192F] text-white pt-44 pb-32 relative overflow-hidden">
        <div className="absolute -top-40 -left-40 h-[36rem] w-[36rem] rounded-full bg-[#1B3563]/40 blur-[120px]" aria-hidden />
        <div className="container-x relative">
          <p className="eyebrow text-[#C5A059]">Resources</p>
          <h1 className="editorial-display text-[clamp(2.8rem,7.4vw,7.5rem)] mt-10 max-w-5xl">
            Curated <br /><span className="italic text-[#C5A059]">professional resources.</span>
          </h1>
          <p className="text-white/70 mt-12 max-w-2xl text-lg lg:text-xl leading-[1.7]">
            Direct links to authoritative sources our practice refers to — Income-tax, Goods and Services Tax, ICAI and the Ministry of Corporate Affairs.
          </p>
        </div>
      </section>

      <section className="bg-white">
        <div className="container-x py-24 lg:py-32 grid grid-cols-1 md:grid-cols-2 gap-px bg-[#0A192F]/10 border border-[#0A192F]/10">
          {RESOURCES.map((group, gi) => (
            <Reveal key={group.section} delay={gi * 90}>
              <div data-testid={`resource-group-${gi}`} className="bg-white p-10 lg:p-14 h-full">
                <span className="num-tag">{String(gi+1).padStart(2,"0")}</span>
                <h2 className="font-serif text-3xl lg:text-4xl text-[#0A192F] mt-8 leading-tight">{group.section}</h2>
                <ul className="mt-10 divide-y divide-[#0A192F]/10">
                  {group.items.map((it) => (
                    <li key={it.label}>
                      <a
                        href={it.href}
                        target="_blank"
                        rel="noreferrer"
                        data-testid={`resource-link-${it.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                        className="flex items-center justify-between py-5 group"
                      >
                        <span className="text-[#0A192F] group-hover:text-[#C5A059] transition-colors">{it.label}</span>
                        <ExternalLink size={16} className="text-[#64748B] group-hover:text-[#C5A059] transition-colors" />
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
